import React from 'react';
//import {Grid, Row, Col} from 'react-bootstrap';

const NoLayout = ({component:Component, ...props}) => 
(            
    <Component {...props}/>
);

export default NoLayout;